import { useSharedTranslation } from 'Translation/useSharedTranslation';
import { GuidLineComponent } from './EmrysNutritionStyle';
const GuidLineNutritionMobile = () => {
    const { t } = useSharedTranslation();

    return (
        <GuidLineComponent>
            <svg
                style={{ width: '100%', height: 'auto' }}
                viewBox='0 0 430 1198'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M0 0H430V1198H0V0Z'
                    fill='#CCF5B9'
                    fillOpacity='0.25'
                />
                <path
                    d='M220 225H250.201C407.5 225 382 365.5 330.5 365.5M203.56 540H250.201C371 540 400.5 620.5 348.5 672M232.852 847H274.5C426 862.5 413.5 1019.5 244.5 1019.5M82.081 773.5C77.1988 690 169.595 690.5 194 690.5C218.405 690.5 197.6 690.5 250.201 690.5M86.4144 432C108.656 384.5 151.501 381 250.201 381'
                    stroke='#46A418'
                    strokeWidth='2'
                    strokeLinejoin='round'
                    strokeDasharray='9 9'
                />
                <rect
                    width='35.6112'
                    height='29.9144'
                    transform='matrix(0.753187 -0.657806 0.683962 0.729518 226 980.425)'
                    fill='url(#pattern0_2649_110996)'
                />
                <rect
                    width='35.6112'
                    height='29.9144'
                    transform='matrix(-0.77999 -0.625791 0.597892 -0.801577 53.1641 785.634)'
                    fill='url(#pattern1_2649_110996)'
                />
                <rect
                    width='35.6112'
                    height='29.9144'
                    transform='matrix(0.745865 0.666097 -0.639376 0.768895 379.126 658)'
                    fill='url(#pattern2_2649_110996)'
                />
                <rect
                    width='35.6112'
                    height='29.9144'
                    transform='matrix(-0.347306 -0.937752 0.924919 -0.380164 54.8755 433.886)'
                    fill='url(#pattern3_2649_110996)'
                />
                <rect
                    width='35.6112'
                    height='29.9144'
                    transform='matrix(0.877492 0.479591 -0.448343 0.893861 369.607 343.594)'
                    fill='url(#pattern4_2649_110996)'
                />
                <rect
                    width='35.6112'
                    height='29.9144'
                    transform='matrix(0.818986 -0.573813 0.602342 0.798238 210.329 197.78)'
                    fill='url(#pattern5_2649_110996)'
                />
                <circle
                    cx='218.641'
                    cy='224.5'
                    r='7.5'
                    fill='#46A418'
                />
                <circle
                    cx='333.5'
                    cy='366.5'
                    r='7.5'
                    fill='#46A418'
                />
                <circle
                    cx='82.3254'
                    cy='439.5'
                    r='7.5'
                    fill='#46A418'
                />
                <circle
                    cx='338.5'
                    cy='677.5'
                    r='7.5'
                    fill='#46A418'
                />
                <circle
                    cx='82.8179'
                    cy='783.5'
                    r='7.5'
                    fill='#46A418'
                />
                <circle
                    cx='243.5'
                    cy='1018.5'
                    r='7.5'
                    fill='#46A418'
                />
                <defs>
                    <pattern
                        id='pattern0_2649_110996'
                        patternContentUnits='objectBoundingBox'
                        width='1'
                        height='1'
                    >
                        <use
                            xlinkHref='#image0_2649_110996'
                            transform='matrix(0.00661441 0 0 0.00787402 0.0733707 0)'
                        />
                    </pattern>
                    <pattern
                        id='pattern1_2649_110996'
                        patternContentUnits='objectBoundingBox'
                        width='1'
                        height='1'
                    >
                        <use
                            xlinkHref='#image0_2649_110996'
                            transform='matrix(0.00661441 0 0 0.00787402 0.0733707 0)'
                        />
                    </pattern>
                    <pattern
                        id='pattern2_2649_110996'
                        patternContentUnits='objectBoundingBox'
                        width='1'
                        height='1'
                    >
                        <use
                            xlinkHref='#image0_2649_110996'
                            transform='matrix(0.00661441 0 0 0.00787402 0.0733707 0)'
                        />
                    </pattern>
                    <pattern
                        id='pattern3_2649_110996'
                        patternContentUnits='objectBoundingBox'
                        width='1'
                        height='1'
                    >
                        <use
                            xlinkHref='#image0_2649_110996'
                            transform='matrix(0.00661441 0 0 0.00787402 0.0733707 0)'
                        />
                    </pattern>
                    <pattern
                        id='pattern4_2649_110996'
                        patternContentUnits='objectBoundingBox'
                        width='1'
                        height='1'
                    >
                        <use
                            xlinkHref='#image0_2649_110996'
                            transform='matrix(0.00661441 0 0 0.00787402 0.0733707 0)'
                        />
                    </pattern>
                    <pattern
                        id='pattern5_2649_110996'
                        patternContentUnits='objectBoundingBox'
                        width='1'
                        height='1'
                    >
                        <use
                            xlinkHref='#image0_2649_110996'
                            transform='matrix(0.00661441 0 0 0.00787402 0.0733707 0)'
                        />
                    </pattern>
                    <image
                        id='image0_2649_110996'
                        width='129'
                        height='127'
                        xlinkHref='data:image/png;base64,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'
                    />
                </defs>
                <foreignObject
                    x='60'
                    y='30'
                    width='500'
                    height='200'
                    xmlns='http://www.w3.org/1999/xhtml'
                >
                    <div
                        className='GuidLineTitle'
                        style={{ width: '300px' }}
                    >
                        {t('base.nutrition.guidLineTitle')}
                        <tspan fill='#2B6E0A'>*</tspan>
                    </div>
                </foreignObject>
                <text
                    x='20'
                    y='170'
                    fill='#575756'
                    className='GuidLineNumberMobile'
                >
                    1.
                </text>
                <foreignObject
                    x='25'
                    y='180'
                    width='200'
                    height='200'
                    xmlns='http://www.w3.org/1999/xhtml'
                >
                    <div
                        className='GuidLineText'
                        style={{ width: '12em' }}
                    >
                        {t('base.nutrition.guidLineStep1')}
                    </div>
                </foreignObject>

                <text
                    x='255'
                    y='381'
                    fill='#575756'
                    className='GuidLineNumberMobile'
                >
                    2.
                </text>
                <foreignObject
                    x='250'
                    y='390'
                    width='300'
                    height='200'
                    xmlns='http://www.w3.org/1999/xhtml'
                >
                    <div
                        className='GuidLineText'
                        style={{ width: '11em' }}
                    >
                        {t('base.nutrition.guidLineStep2')}
                    </div>
                </foreignObject>
                <text
                    x='20'
                    y='480'
                    fill='#575756'
                    className='GuidLineNumberMobile'
                >
                    3.
                </text>
                <foreignObject
                    x='25'
                    y='490'
                    width='300'
                    height='200'
                    xmlns='http://www.w3.org/1999/xhtml'
                >
                    <div
                        className='GuidLineText'
                        style={{ width: '11em' }}
                    >
                        {t('base.nutrition.guidLineStep3')}
                    </div>
                </foreignObject>
                <text
                    x='250'
                    y='690'
                    fill='#575756'
                    className='GuidLineNumberMobile'
                >
                    4.
                </text>
                <foreignObject
                    x='245'
                    y='705'
                    width='300'
                    height='200'
                    xmlns='http://www.w3.org/1999/xhtml'
                >
                    <div
                        className='GuidLineText'
                        style={{ width: '11em' }}
                    >
                        {t('base.nutrition.guidLineStep4')}
                    </div>
                </foreignObject>
                <text
                    x='20'
                    y='840'
                    fill='#575756'
                    className='GuidLineNumberMobile'
                >
                    5.
                </text>
                <foreignObject
                    x='25'
                    y='850'
                    width='300'
                    height='200'
                    xmlns='http://www.w3.org/1999/xhtml'
                >
                    <div
                        className='GuidLineText'
                        style={{ width: '11em' }}
                    >
                        {t('base.nutrition.guidLineStep5')}{' '}
                        <a
                            className='GuidLineText'
                            style={{ textDecoration: 'underline', color: 'unset' }}
                            href={'https://emrysnutrition.com/fr/'}
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            https://emrysnutrition.com/fr/
                        </a>
                    </div>
                </foreignObject>
                <text
                    x='170'
                    y='1030'
                    fill='#575756'
                    className='GuidLineNumberMobile'
                >
                    6.
                </text>
                <foreignObject
                    x='175'
                    y='1045'
                    width='300'
                    height='200'
                    xmlns='http://www.w3.org/1999/xhtml'
                >
                    <div
                        className='GuidLineText'
                        style={{ width: '12em' }}
                    >
                        {t('base.nutrition.guidLineStep6')}
                    </div>
                </foreignObject>
            </svg>
        </GuidLineComponent>
    );
};

export default GuidLineNutritionMobile;
